export const arrowStyle = {
  top: '50%',
  display: "flex",
  position: "absolute",
  cursor: "pointer",
  width: 30,
  height: 30,
  borderRadius: '50%',
  backgroundColor: '#fff',
  justifyContent: "center",
  alignItems:"center",
  zIndex: 10
};